import { Controller } from "@hotwired/stimulus"

// Release watch paste form: fills the textarea from the clipboard so the
// bookmarklet flow is copy (on the retailer page) -> one click here.
export default class extends Controller {
  static targets = ["field", "status"]

  async paste() {
    try {
      const text = await navigator.clipboard.readText()
      this.fieldTarget.value = text
      this.statusTarget.textContent = `${Math.round(text.length / 1024)} KB pasted`
    } catch (e) {
      this.statusTarget.textContent = "Couldn't read the clipboard; click the box and press ⌘V instead."
      this.fieldTarget.focus()
    }
  }
}
